export interface DemoListing {
  title: string;
  rent: number;
  zip: string;
  rooms: number;
  area: number;
  portal: string;
  minutesAgo: number;
  /** Fields for the Telegram message preview on the landing page. */
  coldRent?: number;
  city: string;
  address: string;
  sentAt: string;
}

/** Demo data for the landing page hero and onboarding preview. */
export const DEMO_LISTINGS: DemoListing[] = [
  {
    title: '2-Zimmer-Altbau mit Balkon, Prenzlauer Berg',
    rent: 1190,
    zip: '10437',
    rooms: 2,
    area: 58,
    portal: 'Immowelt',
    minutesAgo: 1,
    coldRent: 980,
    city: 'Berlin',
    address: 'Stargarder Str. 12, 10437 Berlin',
    sentAt: '14:32',
  },
  {
    title: 'Helle 3-Zimmer-Wohnung nahe Mauerpark',
    rent: 1480,
    zip: '10435',
    rooms: 3,
    area: 74,
    portal: 'Kleinanzeigen',
    minutesAgo: 3,
    coldRent: 1260,
    city: 'Berlin',
    address: 'Schwedter Str. 40, 10435 Berlin',
    sentAt: '14:34',
  },
];
